import { z } from "zod";

/** What a person is telling us. The first three are the ones a button or a box can pre-select. */
export const FEEDBACK_KINDS = ["broken", "idea", "custom_board", "other"] as const;
export type FeedbackKind = (typeof FEEDBACK_KINDS)[number];

export const FEEDBACK_KIND_LABELS: Record<FeedbackKind, string> = {
  broken: "Something's broken",
  idea: "Feature request",
  custom_board: "A custom board or rules",
  other: "Something else",
};

/** Works signed out: an email is optional and only used to reply. */
export const feedbackSchema = z.object({
  kind: z.enum(FEEDBACK_KINDS),
  message: z.string().trim().min(5, "Tell us a little more").max(2000),
  email: z.string().trim().email().max(200).optional(),
  /** Where they were; the server strips anything secret from it. */
  page: z.string().max(300).optional(),
});

export type FeedbackInput = z.infer<typeof feedbackSchema>;
